import { render } from "./ConfirmDialog.vue?vue&type=template&id=3199c446"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__